import React, { useEffect, useState } from 'react';
import { Radio, PlayCircle, CalendarDays } from 'lucide-react';
import api from '../lib/api';
import { toEmbedUrl, isJoinLink } from '../lib/embed';

const fmt = (iso) => { try { return new Date(iso).toLocaleString(undefined, { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); } catch { return ''; } };

const Embed = ({ s, url }) => (isJoinLink(s.platform, url)
  ? <a href={url} target="_blank" rel="noreferrer" className="pill-btn text-xs">Join the session</a>
  : <div className="relative w-full rounded-xl overflow-hidden bg-black" style={{ aspectRatio: '16 / 9' }}><iframe src={toEmbedUrl(url, s.platform)} title={s.title} className="absolute inset-0 w-full h-full" frameBorder="0" allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen /></div>);

const Card = ({ s, kind }) => {
  const url = kind === 'live' ? s.stream_url : s.recording_url;
  return (
    <div className="bg-white/70 rounded-2xl border border-rose/40 p-3" data-testid={`teacher-live-${kind}-${s.id}`}>
      {s.room ? <a href={`/members/live/${s.id}`} className="pill-btn text-xs">{kind === 'live' ? 'Watch in Members\u2019 Room' : 'Open in Members\u2019 Room'}</a> : url && <Embed s={s} url={url} />}
      <div className="mt-2 text-burgundy font-medium leading-snug">{s.title}</div>
      {s.scheduled_at && <div className="text-xs text-mahogany/60">{fmt(s.scheduled_at)}</div>}
    </div>
  );
};

export const TeacherLives = ({ slug }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/live/teacher/${slug}`).then((r) => setItems(r.data || [])).catch(() => {}); }, [slug]);
  const now = Date.now();
  const live = items.filter((s) => s.is_live);
  const upcoming = items.filter((s) => !s.is_live && s.scheduled_at && new Date(s.scheduled_at).getTime() > now).reverse();
  const past = items.filter((s) => !s.is_live && (s.recording_url || (s.room && s.has_recording)) && !(s.scheduled_at && new Date(s.scheduled_at).getTime() > now));
  if (!live.length && !upcoming.length && !past.length) return null;
  return (
    <section className="max-w-[1000px] mx-auto px-6 lg:px-10 pb-16 space-y-8" data-testid="teacher-lives">
      {live.length > 0 && <div><h2 className="font-serif-display text-2xl text-burgundy flex items-center gap-2 mb-3"><Radio className="w-5 h-5 text-red-600" /> Live now</h2><div className="grid md:grid-cols-2 gap-4">{live.map((s) => <Card key={s.id} s={s} kind="live" />)}</div></div>}
      {upcoming.length > 0 && (
        <div><h2 className="font-serif-display text-2xl text-burgundy flex items-center gap-2 mb-3"><CalendarDays className="w-5 h-5 text-rose-italic" /> Upcoming live sessions</h2>
          <ul className="space-y-2">{upcoming.map((s) => <li key={s.id} className="bg-white/70 rounded-xl border border-rose/40 px-4 py-3 text-sm flex flex-wrap justify-between gap-2" data-testid={`teacher-live-upcoming-${s.id}`}><span className="text-burgundy font-medium">{s.title}</span><span className="text-mahogany/70">{fmt(s.scheduled_at)}</span></li>)}</ul></div>
      )}
      {past.length > 0 && <div><h2 className="font-serif-display text-2xl text-burgundy flex items-center gap-2 mb-3"><PlayCircle className="w-5 h-5 text-rose-italic" /> Past sessions</h2><div className="grid md:grid-cols-2 gap-4">{past.slice(0, 6).map((s) => <Card key={s.id} s={s} kind="past" />)}</div></div>}
    </section>
  );
};

export default TeacherLives;
